export const VALID_SESSION_LENGTH = 30 * 60 * 1000; // 30 minutes

export function getExpirationTimestamp() {
  return Date.now() + VALID_SESSION_LENGTH;
}
